import {LANGUAGES, STORE, FIXED_LANGUAGES, STORE_LANGUAGES} from "../constants/storeCode";

export const initialState = localStorage.getItem("store")
  ? JSON.parse(localStorage.getItem("store"))
  : 1;

export const setStore = (store, storeM2) => {
  store.setState({ store: storeM2 }, () =>
    localStorage.setItem("store", storeM2)
  );
};

export const initLanguage = (store) => {
    const locale = localStorage.getItem("i18nextLng");
    const currentStore = localStorage.getItem("store");
    const storeLanguage = STORE_LANGUAGES[currentStore];

    if (!locale || !LANGUAGES.hasOwnProperty(locale)) {
        if (storeLanguage) {
            localStorage.setItem("i18nextLng", storeLanguage);
        } else {
            localStorage.setItem("i18nextLng", "de");
        }
    }
};

export const getAvailableLanguages = () => {
    const currentStore = localStorage.getItem("store");
    const storeLanguage = STORE_LANGUAGES[currentStore];

    return {
        "storeLanguage": storeLanguage,
        ...FIXED_LANGUAGES,
    };
};

